import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import i18next from 'i18next';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useTheme } from '@emotion/react';

export default function LanguageDropdown({color='secondary.text'}) {
    const { i18n } = useTranslation();
    // const [anchorEl, setAnchorEl] = useState(null);
    // const open = Boolean(anchorEl);
    let lng = i18next.language;
    // const themeM = useTheme();
    // const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    // const handleMenuOpen = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };
    // const handleMenuClose = () => {
    //     setAnchorEl(null);
    // };
    // const changeLanguage = (language) => {
    //     i18n.changeLanguage(language);
    //     handleMenuClose();
    // };

    const toggleLanguage = () => {
        const otherLng = lng === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(otherLng);
    };
    return (
        <>
            {/* {isMobile ?  */}
            <Typography onClick={toggleLanguage} color={color} fontWeight={'bold'} variant='h6' sx={{cursor:'pointer'}} >{lng === 'en' ? 'AR' : 'EN'}</Typography> 
            {/* // :
            //     <>
            //         <IconButton role='button' onClick={handleMenuOpen} color={color} sx={{ ':hover': { background: 'none' } }} >
            //             <Typography color={color} fontWeight={'bold'} sx={{
            //                 fontSize: 18,
            //                 textTransform: 'capitalize',
            //             }}>
            //                 {lng === 'en' ? 'العربية' : 'الانجليزية'}
            //             </Typography>
            //             <ExpandMoreIcon color={color} sx={{fill: theme => theme.palette.secondary.text }} />
            //         </IconButton>
            //         <Menu
            //             anchorEl={anchorEl}
            //             open={open}
            //             onClose={handleMenuClose}
            //             anchorOrigin={{
            //                 vertical: 'bottom',
            //                 horizontal: 'right',
            //             }}
            //             transformOrigin={{
            //                 vertical: 'top',
            //                 horizontal: 'right',
            //             }}
            //         >
            //             <MenuItem onClick={() => changeLanguage('ar')}>
            //                 العربية
            //             </MenuItem>
            //             <MenuItem onClick={() => changeLanguage('en')}>
            //                 English
            //             </MenuItem>
            //         </Menu>
            //     </>} */}
        </>
    );
}
